<template>
  <div class="DonutDisplay">
    <Card :title="title">
      <pieChart :width="468" type="pie" :options="options" :series="series" />
    </Card>
  </div>
</template>

<script>
import pieChart from 'vue-apexcharts';

import Card from './Card';

export default {
  name: 'CircleDisplay',
  components: {
    Card,
    pieChart,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    options: {
      type: Object,
      required: true,
    },
    series: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss"></style>
